module.exports = __webpack_public_path__ + "img/VL_13_03.14b1b190.png";